import { websocket } from '@/src/shared/lib/websocket'

// export type VideoCallWebsocketSendSkipPayload = string

export function websocketSendNext(): void {
  // payload: VideoCallWebsocketSendSkipPayload
  websocket.emitDefault('next', undefined)
}
